import { render, staticRenderFns } from "./MgmtPracticesDetails.vue?vue&type=template&id=93f43820&scoped=true&"
import script from "./MgmtPracticesDetails.vue?vue&type=script&lang=js&"
export * from "./MgmtPracticesDetails.vue?vue&type=script&lang=js&"
import style0 from "./MgmtPracticesDetails.vue?vue&type=style&index=0&id=93f43820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f43820",
  null
  
)

export default component.exports